export {
  default,
  ModalContextProvider,
  defaultContext as defaultModalContext
} from './ModalContext';
